/**
 * The three limits of a test webinar. Mirrors Grains/Webinar/TestWebinarRules.cs — change both.
 * (spec docs/superpowers/specs/2026-09-03-test-webinar-design.md §4.1)
 */
export const TEST_WEBINAR_MAX_DURATION_MINUTES = 15;
export const TEST_WEBINAR_MAX_VIEWERS = 5;
export const TEST_WEBINAR_DELETE_AFTER_START_HOURS = 24;

const MINUTE_MS = 60_000;
const HOUR_MS = 60 * MINUTE_MS;

/** When a test webinar is deleted: its planned start plus 24 h, as an ISO string. Mirrors TestWebinarRules.DeleteOn. */
export function testWebinarDeleteOn(broadcastDateTime: string): string {
    return new Date(new Date(broadcastDateTime).getTime() + TEST_WEBINAR_DELETE_AFTER_START_HOURS * HOUR_MS).toISOString();
}

/**
 * When the server ends a started test webinar: the earlier of StartedOn + 15 min and the booking's
 * end, as epoch milliseconds. Null before the start. Mirrors TestWebinarRules.EndDeadline.
 */
export function testWebinarEndDeadline(startedOn: string | null | undefined, endOn: string | null | undefined): number | null {
    if (!startedOn) return null;
    const cap = new Date(startedOn).getTime() + TEST_WEBINAR_MAX_DURATION_MINUTES * MINUTE_MS;
    if (!endOn) return cap;
    return Math.min(cap, new Date(endOn).getTime());
}
